import { createAction } from '@'
import { SetFormValues } from '@form'
import { SetModalVisible } from '@modal'
import GetCatalogs from './GetCatalogs'

export default createAction('OpenHotelEditor', async (mode, hotel = {}) => {
    await GetCatalogs()
    const suppliers = {}
    ;(hotel.suppliers || []).forEach(item => {
        suppliers[item.column] = item.supplier_hotel_id
    })
    SetFormValues('HotelCoverageEditor', {
        mode,
        hotel_id: hotel.hotel_id || '',
        country_code: hotel.country_code || '',
        timezone: hotel.timezone || '',
        rank: typeof hotel.rank === 'number' ? hotel.rank : null,
        is_active: mode === 'edit' ? !!hotel.is_active : true,
        suppliers,
        regions: ''
    })
    SetModalVisible('HotelCoverageEditor', true)
})
